export const ASK_FOR_RATE = '[RATES] ASK_FOR_RATE'
export const LOAD_RATES = '[RATES] LOAD_RATES'
export const GET_LEVEL_STATS = '[RATES] GET_LEVEL_STATS'
